<p>usecase-base works!</p>
